import { css } from "styled-components";

export default {
  colors: {
    red: "red",
    salmon: "#de4b4b",
    blue: "#4A90E2",
    blueDark: "#005baa",
    herrBlue: "#4363a0",
    purpleDark: "#061e28",
    green: "green",
    teal: "#43bcba",
    black: "#000000",
    white: "#FFFFFF",
    greyLight: "#f3f3f3",
    greyAccent: "#d3d3d3",
    halfGrey: "linear-gradient(to bottom, transparent 50%, #f3f3f3 50%)",
    greyDient:
      "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
    greyDientReverse:
      "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
    grey: "#c3c3c3",
    greyDark: "#979797",
    greyTimeline: "#4A4A4A",
    dark: "#000914",
    transparent: "rgba(0, 0, 0, 0)"
  },
  media: {
    mobile: (...args) => css`
      @media (max-width: 600px) {
        ${css(...args)}
      }
  `,
    tablet: (...args) => css`
      @media (max-width: 900px) {
        ${css(...args)}
      }
  `,
    desktop: (...args) => css`
      @media (max-width: 1200px) {
        ${css(...args)}
      }
  `,
    card: (...args) => css`
      @media (max-width: 945px) {
        ${css(...args)}
      }
  `
  }
};



// WEBPACK FOOTER //
// ./src/styles/theme.js